var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.023 18.8447C18.5546 18.3961 18.0988 17.9346 17.656 17.4607C17.284 17.0827 17.06 16.8077 17.06 16.8077L14.26 15.4707C15.381 14.1993 15.9997 12.5627 16 10.8677C16 7.00873 12.86 3.86773 9 3.86773C5.14 3.86773 2 7.00873 2 10.8677C2 14.7267 5.14 17.8677 9 17.8677C10.763 17.8677 12.37 17.2077 13.603 16.1287L14.94 18.9287C14.94 18.9287 15.215 19.1527 15.593 19.5247C15.98 19.8877 16.489 20.3787 16.977 20.8917L18.335 22.2837L18.939 22.9297L21.06 20.8087L20.414 20.2047C20.035 19.8327 19.529 19.3387 19.023 18.8447ZM9 15.8677C6.243 15.8677 4 13.6247 4 10.8677C4 8.11073 6.243 5.86773 9 5.86773C11.757 5.86773 14 8.11073 14 10.8677C14 13.6247 11.757 15.8677 9 15.8677Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8fca3bcffda8c7dc4562bfc6c9f65a83.svg";
export { ForwardRef as ReactComponent };